import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pkmh9hr2u4: FaireBrandEntity = {
  token: "b_pkmh9hr2u4",
  type: "brand",
  name: "Rwildlife",
  avatarUrl:
    "https://cdn.faire.com/fastly/7cd724acf92fa53856376e5721f0a8ebb5cc5c0916e13aa1f98e2310e0d3c651.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6f0ee52fb3cb1adfea1d68612a3a82af2c1e7bf3957fe4014fd25947cd6c19bd.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7cd724acf92fa53856376e5721f0a8ebb5cc5c0916e13aa1f98e2310e0d3c651.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6f0ee52fb3cb1adfea1d68612a3a82af2c1e7bf3957fe4014fd25947cd6c19bd.jpeg",
  location: "Boynton Beach, FL, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 4,
  isTopShop: true,
  isInsider: true,
  description:
    "Rwildlife started in 2021 with the passion of creating handmade products, using high quality ingredients. At Rwildlife we believe the best things in life are made one small batch at a time. Our candles capture the essence of a perfect moment in each jar and use simple, sustainable ingredients inspired by nature. Our goal is to give back to our communities and donate partial proceeds to wildlife conservation and animal rescues. \n\nIn addition, all orders are shipped using recycled packaging to help with sustainability and reduce waste.\n\nThank you for checking out our shop and we truly hope you enjoy our products!",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:46.408Z",
    importedBy: "entity-db-cli",
  },
};
